const getBrowserQueryString = require("../dom/getBrowserQueryString");
const getPreferenceCenterOptionsFromQueryString = require("./getPreferenceCenterOptionsFromQueryString");

/**
 * @return {null | PreferenceCenterOptions}
 */
module.exports = function getPreferenceCenterOptionsFromBrowserUrl() {
    const queryString = getBrowserQueryString();

    if (queryString) {
        return getPreferenceCenterOptionsFromQueryString(queryString);
    }

    return null;
}
